import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import AccessoriesVideoSmall from "./AccessoriesVideoSmall";
import AccessoriesVideoMedium from "./AccessoriesVideoMedium";
import AccessoriesVideoTable from "./AccessoriesVideoTable";
import StaticVideoFunctions from "../../utils/StaticVideoFunctions";
import IFrameContainer from "../../utils/IFrameContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import ModuleNav from "../../mainFrame/ModuleNav";

class AccessoriesContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            activeView: 'smallView',
            videoList: null,
        };

        this.translate = this.props.baseData.translate;

        this.requestAccessoriesVideos = this.requestAccessoriesVideos.bind(this);
        this.handleViewChange = this.handleViewChange.bind(this);
        this.getVideoById = this.getVideoById.bind(this);
        this.setModalContent = this.setModalContent.bind(this)

    }

    componentWillMount() {

        this.requestAccessoriesVideos();

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};

        //  View aus den userprops laden
        const activeView = (settings.viewVideos) ? settings.viewVideos : 'smallView';

        if (activeView) state.activeView = activeView;

        this.setState(state);

    }

    requestAccessoriesVideos() {

        const params = {
            companyId: this.props.baseData.companies.currentCompany.id,
            filter: {},
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    videoList: res,
                });
            }
        }.bind(this);

        this.api.request('GetAccessoriesVideos', params, callback, null);

    }

    handleViewChange(view) {

        this.props.baseData.saveSettings('viewVideos', view);

        this.setState({activeView: view});

    }

    getVideoById(videoId) {

        const videoList = this.state.videoList;

        let videoData = null;

        if (videoList.length) {
            videoData = videoList.find(
                (video) => {
                    return video.video_id === videoId;
                }
            );
        }

        return videoData;

    }

    setModalContent(v) {

        if (!v) return null;

        const videoData = this.getVideoById(v);
        const videoUrl = StaticVideoFunctions.getVideoUrl(videoData.video_id, this.props.video_source);

        this.props.baseData.modalData({
            content: <IFrameContainer
                height="replaceModalContentHeight"
                width="replaceModalContentWidth"
                src={videoUrl}
            />
        });

    }

    renderVideos() {

        if (!this.state.videoList) return <LoadingSplash color={'dark'}/>;

        if (this.state.videoList.length) {
            const videoSource = 'YouTube';
            const videos = this.state.videoList;
            const activeView = this.state.activeView;

            if (activeView === 'smallView') {
                return <AccessoriesVideoSmall
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={videoSource}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'mediumView') {
                return <AccessoriesVideoMedium
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={videoSource}
                    translate={this.translate}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'tableView') {
                return <AccessoriesVideoTable
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={videoSource}
                    onClick={this.setModalContent}
                />;
            } else {
                return this.translate('noViewFound');
            }
        }

        return this.translate('noVideosFound');

    }

    render() {

        const archivAreaClasses = ['archivArea', this.state.activeView].join(' ').trim();
        const videos = this.renderVideos();

        return (
            <div className="accessoriesContainer">
                <nav>
                    <h1>{this.translate('accessories')}</h1>

                    <ModuleNav
                        translate={this.translate}
                        activeView={this.state.activeView}
                        onClick={this.handleViewChange}
                    />
                </nav>

                <div className={archivAreaClasses}>
                    <div className="fadeInArea clearfix">
                        {videos}
                    </div>
                </div>
            </div>
        );

    }

}

export default AccessoriesContainer;